import { User } from 'lib-shared-types-api';
import { DeepWritable } from 'ts-essentials';

import { usersApi } from 'apis/users';
import { api } from 'app/app.api';

import {
  MergeContactsApiArg,
  MergeContactsApiResponse,
} from './types/contactsApi.types';

export const contactsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    mergeContacts: builder.mutation<
      MergeContactsApiResponse,
      MergeContactsApiArg
    >({
      query: ({ target, sources, strategy, dryRun }) => ({
        version: 1,
        method: 'POST',
        path: `contacts/merge`,
        params: {
          dryRun,
        },
        body: { target, sources, strategy },
      }),
      async onQueryStarted({ dryRun }, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { data: contact },
          } = await queryFulfilled;

          if (!dryRun) {
            dispatch(
              usersApi.util.updateQueryData(
                'readUser',
                { id: contact.id },
                (draft) => {
                  const mutableUser = draft.data as DeepWritable<User>;

                  for (const [key, value] of Object.entries(contact)) {
                    mutableUser[key] = value;
                  }
                },
              ),
            );
          }
        } catch {
          /* do nothing */
        }
      },
    }),
  }),
});
